/**
 * Утилита для проверки IP сервера
 * Показывает предупреждение пользователю, если запрос идет не на ожидаемый сервер
 */

// Ожидаемый IP сервера
const EXPECTED_SERVER_IP = '178.66.50.117';

// Флаг, чтобы не показывать алерт слишком часто
let alertShown = false;

// Event Bus для Vue компонентов
let eventBus = null;

/**
 * Устанавливает Event Bus для взаимодействия с Vue компонентами
 * @param {Object} bus - Event Bus объект
 */
export function setEventBus(bus) {
  eventBus = bus;
}

/**
 * Проверяет, является ли hostname ожидаемым сервером
 * @param {string} url - URL запроса
 * @returns {Object} - Объект с информацией о сервере
 */
function analyzeServerFromURL(url) {
  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname;
    
    // Проверяем, является ли hostname IP адресом
    const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    
    if (ipRegex.test(hostname)) {
      // Это IP адрес - сравниваем напрямую
      return {
        hostname,
        isIP: true,
        isExpectedServer: hostname === EXPECTED_SERVER_IP
      };
    } else {
      // Это доменное имя - нужно проверить, не является ли оно ожидаемым доменом
      const expectedDomains = [
        'api.chapterfour.ru',
        'chapterfour.ru', 
        'www.chapterfour.ru'
      ];
      
      return {
        hostname,
        isIP: false,
        isExpectedServer: expectedDomains.includes(hostname.toLowerCase())
      };
    }
  } catch (error) {
    console.warn('Не удалось проанализировать URL:', error);
    return {
      hostname: 'неизвестен',
      isIP: false,
      isExpectedServer: false
    };
  }
}

/**
 * Проверяет IP сервера и показывает предупреждение при необходимости
 * @param {string} url - URL запроса
 */
export function checkServerIP(url) {
  // Если алерт уже был показан в этой сессии, не показываем повторно
  if (alertShown) {
    return;
  }
  
  const serverInfo = analyzeServerFromURL(url);
  
  // Если не удалось определить сервер, пропускаем проверку
  if (!serverInfo || serverInfo.hostname === 'неизвестен') {
    return;
  }
  
  // Если это не ожидаемый сервер, показываем предупреждение
  if (!serverInfo.isExpectedServer) {
    showServerWarning(serverInfo);
    alertShown = true;
  }
}

/**
 * Показывает предупреждение пользователю
 * @param {Object} serverInfo - Информация о текущем сервере
 */
function showServerWarning(serverInfo) {
  // Пытаемся использовать модальное окно через Event Bus
  if (eventBus && typeof eventBus.emit === 'function') {
    eventBus.emit('show-server-warning', {
      currentIP: serverInfo.hostname,
      expectedIP: serverInfo.isIP ? EXPECTED_SERVER_IP : 'api.chapterfour.ru',
      isCurrentIP: serverInfo.isIP
    });
    return;
  }
  
  // Fallback на обычный alert, если Event Bus недоступен
  const expectedDisplay = serverInfo.isIP ? EXPECTED_SERVER_IP : 'api.chapterfour.ru';
  const message = `⚠️ ВНИМАНИЕ: Обновление сервера ⚠️

Новый сервер еще не вступил в силу. 
Настоятельно рекомендуем воздержаться от выполнения действий в админке.

Что можно попробовать:
• Нажмите Shift + F5 (Windows/Linux)  
• Нажмите Cmd + Shift + R (Mac)
• Подождите несколько минут и обновите страницу

Текущий сервер: ${serverInfo.hostname}
Ожидаемый сервер: ${expectedDisplay}`;

  alert(message);
}

/**
 * Сбрасывает флаг показа алерта (для тестирования или принудительного показа)
 */
export function resetAlertFlag() {
  alertShown = false;
}

/**
 * Проверяет, показывался ли уже алерт
 * @returns {boolean}
 */
export function isAlertShown() {
  return alertShown;
} 